/**
 * ajax 模块，可以将 axios 替换成 $.ajax 等
 */
import axios from 'axios';
// import globalConfig from '../config'

const GET_I18N = '/static/i18n/'
const init = function () {
  axios.interceptors.request.use(function (config) {
    if (config.url.indexOf(GET_I18N) < 0) {
      config.url = window.localStorage.gatewayDomain + config.url
    }
    // var cookies = globalConfig.getCookies()
    // config.url += ('access_token=' + cookies['access_token'])
    if (!config.data) config.data = {}
    return config;
  }, function (err) {
    return Promise.reject(err)
    // return (err)
  })

  // Add a response interceptor
  axios.interceptors.response.use(function (response) {
    const {status, data} = response;

    if (status === 200) {
      // 如果不出现错误，直接向回调函数内输出 data
      if (data.error === 'SUCCESS') {
        return data
      } else {
        return data
      }
    } else {
      return response;
    }
  }, function (error) {
    const {response} = error;

    // 这里处理错误的 http code
    if (!response || response.status === 404) {
      console.log('404 error %o' + error);
    }
    // return (error)
    // Do something with response error
    return Promise.reject(error);
  });
};

export default {
  init
}



// WEBPACK FOOTER //
// ./src/services/ajax.js